<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <td v-bind="attrs"
                    :style="isArabic(row) ? 'direction: rtl;' : ''"
                    v-on="on">
                    {{ truncate(row, length) }}
                </td>
            </template>
            <span>{{ row }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import isArabic from '@/utils/isArabic';
import truncate from '@/utils/truncate';
export default {
    name: "PTableWidth",
    props: {
        row: {
            type: String,
            required: false
        },
        length: {
            type: Number,
            default: 30
        }
    },
    methods: {
        isArabic,
        truncate
    }
}
</script>

<style>

</style>